define("shared/helpers/format-number-to-locale-string", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * Formats a number to a locale-specific string if it is 1000 or greater.
   * If the input is not a number or is less than 1000, it returns the original value.
   *
   * @param {Array<number|string>} params - An array containing a single value (number or string).
   * @returns {string|number} - The formatted number as a string or the original value.
   */
  function formatNumberToLocaleString(_ref) {
    let [value] = _ref;
    if (typeof value === 'number' && value >= 1000) {
      return value.toLocaleString();
    }
    return value;
  }
  var _default = _exports.default = (0, _helper.helper)(formatNumberToLocaleString);
});